import { View } from '@play-co/timestep-core/ui';
import { spineLoader } from '@play-co/timestep-spine';
import gsap from 'gsap';
import SpineAnimationView from 'src/game/components/shared/SpineAnimationView';
import { waitFor } from 'src/game/minigame/match2-timestep/lib/util/waitFor';
import sounds from 'src/lib/sounds';

export const streakCloudMascotAssets = {
  loadMethod: spineLoader,
  url: 'assets/ui/match2/streakbattleroyaleV2/spines/cloud/spine.mtfuji.cloud',
};

type AnimationId = 'idle' | 'surrender' | 'attack';
type AttackOpts = {
  x: number;
  y: number;
  scale: number;
  onAttacked?: () => void;
};

const defaultTransforms = { x: 120, y: 740, scale: 0.64 };
const moveDuration = 0.5;

export default class StreakCloudMascot extends SpineAnimationView {
  private currentAnimation!: AnimationId;

  // Hash for invalidating an overwritten attack cycle - purposely just for debugging actions
  private attackHash?: symbol;

  constructor(superview: View) {
    super({
      superview,
      spinePath: streakCloudMascotAssets.url,
      zIndex: 6,
      ...defaultTransforms,
    });

    this.idle();
  }

  public idle() {
    if (this.currentAnimation === 'idle') {
      return;
    }

    this.currentAnimation = 'idle';
    this.start({ id: 'idle', loop: true });
  }

  public surrender() {
    if (this.currentAnimation === 'surrender') {
      return;
    }

    this.currentAnimation = 'surrender';
    this.start({ id: 'surrender', loop: true });
  }

  public async attack({ x, y, scale, onAttacked }: AttackOpts) {
    const hash = Symbol();
    this.attackHash = hash;

    await gsap.to(this.style, {
      duration: moveDuration,
      x,
      y,
      scale,
      ease: 'quad.inOut',
      overwrite: true,
    });

    if (this.attackHash !== hash) {
      return;
    }

    waitFor(255).then(() => {
      sounds.sfx.play('fujiquest-zap');
      onAttacked?.();
    });

    this.currentAnimation = 'attack';

    await this.start({ id: 'attack', mix: 0 }).complete;

    if (this.attackHash !== hash) {
      return;
    }

    this.idle();

    await gsap.to(this.style, {
      duration: moveDuration,
      ...defaultTransforms,
      ease: 'quad.inOut',
      overwrite: true,
    });
  }
}
